import * as Immutable from 'immutable';
import {  } from '../../../UserData/_actions/UserCartActions';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import OrderModal, { Props } from '../_components/OrderModal';
import { SetOrderingStatus } from '../../../UIData/_actions/UIDataActions';

const mapStateToProps = (store:Immutable.Record<any>, props: Props) => ({
	id: store.getIn(['UIData', 'ordering', 'id']),
	productType: store.getIn(['UIData', 'ordering', 'productType']),
	status: store.getIn(['UIData', 'ordering', 'status']),
	patterns: store.getIn(['userData', 'patterns', 'items'])
});

const mapDispatchToProps = (dispatch:Dispatch, props:Props) => ({
	setOrderingStatus: (status: boolean) => dispatch(SetOrderingStatus(status)),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(OrderModal);